export enum AdStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  ARCHIVED = 'ARCHIVED',
}

export enum AD_BUDGET_FREQUENCY {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY',
}

export const AD_BUDGET_FREQUENCY_TITLE: Record<AD_BUDGET_FREQUENCY, string> = {
  [AD_BUDGET_FREQUENCY.MONTHLY]: 'month',
  [AD_BUDGET_FREQUENCY.WEEKLY]: 'week',
  [AD_BUDGET_FREQUENCY.YEARLY]: 'year',
};

export const AD_BUDGET_FREQUENCY_OPTIONS = (
  Object.keys(AD_BUDGET_FREQUENCY) as (keyof typeof AD_BUDGET_FREQUENCY)[]
).map((key) => {
  return {
    label: AD_BUDGET_FREQUENCY_TITLE[AD_BUDGET_FREQUENCY[key]],
    value: AD_BUDGET_FREQUENCY[key],
  };
});

export enum AdAction {
  Approve = 'approve',
  Rework = 'rework',
  Delete = 'delete',
}
